<template>
  <div class="well page">

    <div class="row">
      <h2>Request Urgency</h2>
      <div id="showMsg"><!-- Error messages etc are shown here --></div>
      <label>Within how many <i>business</i> days would you like this maintenance request completed?</label>
    </div>

    <div class="row" v-if="job">
      <div class="col-md-4">
        <div
            class="panel panel-default checkoption hvr-grow hvr-fix"
            :class="{'checkoption-checked': urgent}"
            @click="set_urgent"
        >
          <div class="panel-body">
            This is urgent, ASAP!
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div
            class="panel panel-default checkoption hvr-grow hvr-fix"
            :class="{'checkoption-checked': urgency_days == 3 && !picked}"
            @click="urgency(3)"
        >
          <div class="panel-body">
            Within 3 days
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div
            class="panel panel-default checkoption hvr-grow hvr-fix"
            :class="{'checkoption-checked': urgency_days == 5 && !picked}"
            @click="urgency(5)"
        >
          <div class="panel-body">
            Within 5 days
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div
            class="panel panel-default checkoption hvr-grow hvr-fix"
            :class="{'checkoption-checked': urgency_days == 14 && !picked}"
            @click="urgency(14)"
        >
          <div class="panel-body">
            Within 14 days
          </div>
        </div>
      </div>

      <dropdown class="col-md-4">
        <div
            class="panel panel-default checkoption hvr-grow hvr-fix"
            :class="{'checkoption-checked': picked}"
            data-role="trigger"
        >
          <div class="panel-body">
            Let me select a date <i v-if="picked">({{ urgency_days }})</i>
          </div>
        </div>
        <template slot="dropdown">
          <li>
            <date-picker
                v-model="date"
                :week-starts-with="0"
                :clear-btn="false"
                :today-btn="false"
                :limit-from="now"
                class="picker"
            ></date-picker>
          </li>
        </template>
      </dropdown>
    </div>

    <div class="row">
      <button
          class="btn btn-primary pull-right"
          :disabled="!urgency_days"
          @click="review"
      >Review Request <i class="glyphicon glyphicon-share-alt"></i></button>
    </div>
  </div>
</template>

<style scoped>
  .picker .btn {
    border: none;
  }
</style>

<script>
  import moment from "moment"

  import {mapGetters} from "vuex"
  import {Dropdown, DatePicker} from "uiv"

  export default {
    async created () {
      let promises = [
        this.$store.dispatch("get_jobs", {job_id: this.$route.params.job_id, lazy: true}),
        this.$store.dispatch("get_stores", true)
      ];
      await Promise.all(promises);

      this.$store.commit("select_job", this.$route.params.job_id);
      this.$store.commit("select_store", this.job.store);

      this.urgency_days = this.job.urgency_days;
      this.urgent = this.job.urgent;
    },
    data () {
      return {
        picked: false,
        date: null,
        now: new Date(),
        urgency_days: 0,
        urgent: false
      }
    },
    computed: mapGetters([
      "job"
    ]),
    methods: {
      set_urgent () {
        this.urgent = true;
        this.urgency_days = 1;
        this.date = null;
      },
      urgency (days) {
        this.urgent = false;
        this.urgency_days = days;
        this.date = null;
      },
      pick_day () {
        this.picked = true;

        let tmp_moment = moment(this.date, "YYYY-MM-DD");
        tmp_moment.hour(23);
        tmp_moment.minute(59);

        let days = this.calc_work_days(new Date(), tmp_moment.toDate()) - 1;
        if (days === 0) {
          days = 1;
        }
        this.urgency_days = days;
        this.urgent = false;
      },
      calc_work_days(start_date, end_date) {
        if (end_date < start_date) return 0;

        let ms_per_day = 86400 * 1000; // Day in milliseconds
        start_date.setHours(0,0,0,1);  // Start just after midnight
        end_date.setHours(23,59,59,999);  // End just before midnight
        let diff = end_date - start_date;  // difference in ms
        let days = Math.ceil(diff / ms_per_day);

        let weeks = Math.floor(days / 7);
        days = days - (weeks * 2);

        let start_day = start_date.getDay();
        let end_day = end_date.getDay();

        // Special cases..
        if (start_day - end_day > 1) days = days - 2; // Remove weekend not previously removed
        if (start_day === 0 && end_day !== 6) days = days - 1; // Remove start day if starts on Sunday but ends before Saturday
        if (end_day === 6 && start_day !== 0) days = days - 1; // Remove end day if span ends on Saturday but starts after Sunday

        return days;
      },
      async review () {
        await this.$store.dispatch("set_job_urgency", {
          job_id: this.job.id,
          urgent: this.urgent,
          urgency_days: this.urgency_days,
        });
        this.$router.push({
          name: "job-review",
          job_id: this.job.id
        });
      }
    },
    components: {
      Dropdown,
      DatePicker
    },
    watch: {
      date (val) {
        if (!val) {
          this.picked = false;
          return;
        }
        this.pick_day();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// assets/vue/logger/JobUrgency.vue?67d5308a